import { render } from "./LegalDocPage.vue?vue&type=template&id=52d4d5e7&scoped=true"
import script from "./LegalDocPage.vue?vue&type=script&lang=js"
export * from "./LegalDocPage.vue?vue&type=script&lang=js"

import "./LegalDocPage.vue?vue&type=style&index=0&id=52d4d5e7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52d4d5e7"]])

export default __exports__